import { DisplayTransactionType } from '@features/bankTransactions/enums/displayTransactionType'
import { TransactionType } from '@features/bankTransactions/enums/transactionType'

import { Side } from '../../../../../../../enums/side'
import { getTransferType } from '../utils/getTransferType'

export const transactionTypeToDisplayType: Record<TransactionType, (side: Side) => DisplayTransactionType> = {
  [TransactionType.Card]: () => DisplayTransactionType.Card,
  [TransactionType.CashDeposit]: () => DisplayTransactionType.ATM,
  [TransactionType.CashWithdrawal]: () => DisplayTransactionType.ATM,
  [TransactionType.Check]: () => DisplayTransactionType.Unknown,
  [TransactionType.DirectDebit]: () => DisplayTransactionType.DirectDebit,
  [TransactionType.InstantTransfer]: getTransferType,
  [TransactionType.InternalCounterEntry]: () => DisplayTransactionType.Unknown,
  [TransactionType.InternationalTransfer]: getTransferType,
  [TransactionType.IntraCompanyFundsTransfer]: () => DisplayTransactionType.WalletTransfer,
  [TransactionType.PeerToPeer]: () => DisplayTransactionType.Unknown,
  [TransactionType.SwiftTransfer]: getTransferType,
  [TransactionType.Transfer]: getTransferType,
  [TransactionType.Unknown]: () => DisplayTransactionType.Unknown,
  [TransactionType.VirtualCard]: () => DisplayTransactionType.Card,
  [TransactionType.WalletTransfer]: () => DisplayTransactionType.WalletTransfer,
}
